import { format } from 'date-fns'

import { PageType } from '@sportworld/js-sdk/src/types/servicesTypes/pageTypes'
import { MatchItem } from '@sportworld/js-sdk/src/types/soccerDataTypes'
import { createMatchPageLogo } from '@sportworld/js-sdk/src/utils/soccerData'

import {
  commentaryTypes,
  dataWidgetProvider,
  dataWidgetTypes,
  pageTypes,
} from '@/constants/common'
import i18n from '@/i18n'
import { dateRelativeTranslation } from '@/i18n/dateTranslation'

export const formatDateForCommentaryRequest = (date: Date) => {
  const isUSLocale = i18n.language.includes('US')
  const timePreposition = i18n.t('at')
  const timeFormat = isUSLocale ? `h:mm aaa` : `HH:mm`
  const formattedTime = format(date, timeFormat)
  const datePreposition = i18n.t('on')
  const dateFormat = isUSLocale ? `eeee, MM/dd/yyyy` : `eeee, dd.MM.yyyy`
  const relativeDate = dateRelativeTranslation(
    date,
    `'${datePreposition}' ${dateFormat}`,
  )
  return relativeDate + ` ${timePreposition} ` + formattedTime
}

export const createMatchPage = (
  match: MatchItem,
  title: string,
  tournamentCalendarId?: string,
): PageType => ({
  id: match.id,
  title,
  name: '',
  shortTitle: '',
  categoryId: 'sport',
  pageType: pageTypes.TABS,
  withoutFavoriteIcon: true,
  logo: createMatchPageLogo(match.home.id),
  secondLogo: createMatchPageLogo(match.away.id),
  tabs: [
    {
      title: 'Live Ticker',
      type: pageTypes.DATA_WIDGET,
      match,
      dataWidget: {
        dataProvider: dataWidgetProvider.STATS_PERFORM,
        dataType: 'Soccer',
        type: dataWidgetTypes.MATCH,
        statsPerform: {
          tournamentCalendarId,
          contestantId: '',
          fixtureId: '',
          commentary: {
            type: commentaryTypes.AUTO,
          },
        },
      },
    },
  ],
})
